module.exports = __webpack_public_path__ + "static/media/mood-tarot.b1b22695.png";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/mood-tarot.png
// module id = 1344
// module chunks = 0